import formatPhoneForUser from "../../utils/formatPhoneForUser.js";

/** Keep explicit country codes; Rep's existing formatter returns local forms for UK/Australia. */
export function formatVerificationPhone(value: string): string {
  const digits = value.replace(/\D/g, "");
  if (value.trim().startsWith("+") && !value.trim().startsWith("+1")) {
    if (digits.startsWith("44") && digits.length > 2 && digits.length <= 12)
      return `+44 ${formatPhoneForUser(`+${digits}`).replace(/^0/, "")}`.trim();
    if (digits.startsWith("61") && digits.length > 2 && digits.length <= 11)
      return `+61 ${formatPhoneForUser(`+${digits}`).replace(/^0/, "")}`.trim();
    return `+${digits}`;
  }
  const formatted = formatPhoneForUser(digits);
  if (value.trim().startsWith("+1")) return `+1 ${formatted}`.trim();
  if (digits.startsWith("1")) return `1 ${formatted}`.trim();
  return formatted;
}

export function readVerificationPhone(value: string): { value: string; error?: never } | { error: string; value?: never } {
  const trimmed = value.trim();
  if (/[^\d+\s().-]/.test(trimmed) || !/^\+?[^+]*$/.test(trimmed))
    return { error: "Use numbers only, with + at the start for an international number." };
  const digits = trimmed.replace(/\D/g, "");
  const international = trimmed.startsWith("+") && !trimmed.startsWith("+1");
  const maximum = international ? 15 : digits.startsWith("1") ? 11 : 10;
  if (digits.length > maximum)
    return { error: international ? "Phone numbers can have up to 15 digits. Please check the number." : "US and Canadian numbers need 10 digits, plus an optional 1 at the start. For another country, start with +." };
  return { value: formatVerificationPhone(trimmed) };
}

/** Restore the caret by digit position when adding the same spacing used elsewhere in Rep. */
export function phoneCaret(value: string, digitsBefore: number, afterPlus: boolean): number {
  if (!digitsBefore) return afterPlus && value.startsWith("+") ? 1 : 0;
  let seen = 0;
  for (let index = 0; index < value.length; index++) {
    if (/\d/.test(value[index]) && ++seen === digitsBefore) return index + 1;
  }
  return value.length;
}

export function verificationPhoneForComparison(value: string): string {
  const digits = value.replace(/\D/g, "");
  if (value.trim().startsWith("+")) return `+${digits}`;
  return digits.length === 10 ? `+1${digits}` : digits.length === 11 && digits.startsWith("1") ? `+${digits}` : value;
}
